export default __webpack_public_path__ + "static/media/implogo.5a117a9f.png";